import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { ColumnConfigItem } from '../../frontline-winning/model/fl-winning.global.model';
import { WpCommitmentDetail } from '../core/model/wp-commitment-detail.model';
import { SortOrder } from '../grid';

import { getColumnConfigItemsConfig } from './core/column-config';
import {
    sortByDirectReport,
    sortByMetric,
    sortByStartDate,
} from './function/sort-by-commitment-detail.function';

@Injectable()
export class CommitmentDetailsDialogService {
    /** @private */ _commitmentColumnConfig: BehaviorSubject<
        ColumnConfigItem[]
    >;

    /** @private */ _commitmentSortDirectReport: SortOrder;
    /** @private */ _commitmentSortStartDate: SortOrder;
    /** @private */ _commitmentSortMetric: SortOrder;
    constructor(private readonly _translateService: TranslateService) {}

    initializeColumnConfig(): void {
        this._commitmentColumnConfig = new BehaviorSubject<ColumnConfigItem[]>(
            getColumnConfigItemsConfig(this._translateService),
        );
        this._commitmentSortDirectReport = SortOrder.ASC;
        this._commitmentSortStartDate = SortOrder.ASC;
        this._commitmentSortMetric = SortOrder.ASC;
    }

    sortCommitmentByDirectReport(forceDirection?: SortOrder): SortOrder {
        if (this._commitmentSortDirectReport == null)
            this._commitmentSortDirectReport = SortOrder.ASC;
        else if (this._commitmentSortDirectReport === SortOrder.ASC)
            this._commitmentSortDirectReport = SortOrder.DESC;
        else this._commitmentSortDirectReport = SortOrder.ASC;

        this._commitmentSortMetric = this._commitmentSortStartDate = null;

        if (forceDirection != null) {
            this._commitmentSortDirectReport = forceDirection;
        }

        return this._commitmentSortDirectReport;
    }

    sortCommitmentByStartDate(forceDirection?: SortOrder): SortOrder {
        if (this._commitmentSortStartDate == null)
            this._commitmentSortStartDate = SortOrder.ASC;
        else if (this._commitmentSortStartDate === SortOrder.ASC)
            this._commitmentSortStartDate = SortOrder.DESC;
        else this._commitmentSortStartDate = SortOrder.ASC;
        this._commitmentSortMetric = this._commitmentSortDirectReport = null;

        if (forceDirection != null) {
            this._commitmentSortStartDate = forceDirection;
        }

        return this._commitmentSortStartDate;
    }

    sortCommitmentByMetric(forceDirection?: SortOrder): SortOrder {
        if (this._commitmentSortMetric == null)
            this._commitmentSortMetric = SortOrder.ASC;
        else if (this._commitmentSortMetric === SortOrder.ASC)
            this._commitmentSortMetric = SortOrder.DESC;
        else this._commitmentSortMetric = SortOrder.ASC;

        this._commitmentSortDirectReport = this._commitmentSortStartDate = null;

        if (forceDirection != null) {
            this._commitmentSortMetric = forceDirection;
        }

        return this._commitmentSortMetric;
    }

    sortBy(
        type: string,
        force?: SortOrder,
        rawData?: WpCommitmentDetail[],
    ): SortOrder {
        let dir: number;
        if (type === 'directReportSort')
            dir = this.sortCommitmentByDirectReport(force);
        else if (type === 'startDateSort')
            dir = this.sortCommitmentByStartDate(force);
        else dir = this.sortCommitmentByMetric(force);

        this.traverse(type, dir, rawData);
        return dir;
    }

    traverse(
        type: string,
        dir: SortOrder,
        _winningCommitmentDetails: WpCommitmentDetail[],
    ): void {
        if (type === 'directReportSort') {
            _winningCommitmentDetails.sort(sortByDirectReport(dir));
        } else if (type === 'startDateSort') {
            _winningCommitmentDetails.sort(sortByStartDate(dir));
        } else {
            _winningCommitmentDetails.sort(sortByMetric(dir));
        }
    }
}
export function mapper(data: WpCommitmentDetail[]): WpCommitmentDetail[] {
    const commitmentDetails: WpCommitmentDetail[] = [];
    data.forEach((g) => {
        const s: WpCommitmentDetail = {
            ...g,
            behaviourNameTooltip: g.behaviourName,
            subBehaviourNameTooltip: g.subBehaviourName,
            behaviourName:
                g.behaviourName.length > 100
                    ? g.behaviourName.substring(0, 97) + '...'
                    : g.behaviourName,
            subBehaviourName:
                g.subBehaviourName.length > 100
                    ? g.subBehaviourName.substring(0, 97) + '...'
                    : g.subBehaviourName,
        };
        commitmentDetails.push(s);
    });
    return commitmentDetails;
}
